/* Delivery estimate under the add to cart button: working days from today, weekends skipped. */
(function () {
  function addWorkingDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function run() {
    document.querySelectorAll('[data-ls-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      if (!min || !max) return;
      var now = new Date(), a = addWorkingDays(now, min), b = addWorkingDays(now, max);
      var dm = { day: 'numeric', month: 'short' };
      var fa = a.toLocaleDateString('en-GB', a.getMonth() === b.getMonth() ? { day: 'numeric' } : dm);
      var fb = b.toLocaleDateString('en-GB', dm);
      var span = el.querySelector('span');
      if (span) span.textContent = 'Order today and it arrives ' + fa + ' to ' + fb;
    });
  }
  function runTimeline() {
    var dm = { day: 'numeric', month: 'short' };
    document.querySelectorAll('[data-ls2-dl]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      var dis = parseInt(el.getAttribute('data-dispatch'), 10) || 3;
      if (!min || !max) return;
      var now = new Date(), d = addWorkingDays(now, dis), a = addWorkingDays(now, min), b = addWorkingDays(now, max);
      var fa = a.toLocaleDateString('en-GB', a.getMonth() === b.getMonth() ? { day: 'numeric' } : dm);
      var A = el.querySelector('[data-ls2-dl-a]'), B = el.querySelector('[data-ls2-dl-b]'), C = el.querySelector('[data-ls2-dl-c]');
      if (A) A.textContent = 'Today';
      if (B) B.textContent = 'By ' + d.toLocaleDateString('en-GB', dm);
      if (C) C.textContent = fa + ' to ' + b.toLocaleDateString('en-GB', dm);
    });
  }
  function all() { run(); runTimeline(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();
